import React from 'react';

export interface LzPDiv {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function LzXDiv(props: LzPDiv) {
    return (
        <div className={'lz-div ' + (props.className || '')} style={props.style}>
            {props.children}
        </div>
    );
}
